module.exports = __webpack_public_path__ + "images/rich_heading/brand/piano/icon_2f47b321f628ec7d5cd9412b6f0df6b4.png";